import React from 'react';
import { useDraftLocalStorage } from '../../lib/useDraftLocalStorage';
import { Button, message, Modal, Tooltip } from 'antd';
import { fieldNames } from '../../../common/config';
import moment from 'moment';

const { confirm } = Modal;

const fieldsToSave = Object.values(fieldNames).filter(
  (name) => name !== fieldNames.files
);

const hasValueChecker = {
  string: (value) => Boolean(value?.trim()),
  number: (value) => Boolean(value),
  array: (value) => Boolean(value?.length),
  date: (value) => moment.isMoment(value) && value.isValid(),
};

const createShutdownShema = {
  // [fieldNames.addresses]: hasValueChecker.array,
  [fieldNames.reason]: hasValueChecker.number,
  [fieldNames.alisaTemplate]: hasValueChecker.number,
  [fieldNames.alisaText]: hasValueChecker.string,
  [fieldNames.city]: hasValueChecker.number,
  [fieldNames.description]: hasValueChecker.string,
  [fieldNames.endDate]: hasValueChecker.date,
  [fieldNames.responsible]: hasValueChecker.array,
  [fieldNames.initiators]: hasValueChecker.array,
  [fieldNames.notifyTo]: hasValueChecker.array,
  [fieldNames.planEndDate]: hasValueChecker.date,
  [fieldNames.startDate]: hasValueChecker.date,
  [fieldNames.type]: hasValueChecker.number,
  [fieldNames.mainInitiator]: hasValueChecker.number,
  [fieldNames.company]: hasValueChecker.number,
};

const hasAnyValue = (values) =>
  Object.keys(createShutdownShema).some((key) => {
    const checker = createShutdownShema[key];
    return checker(values[key]);
  });

const saveData = (values, set, onCancel) => {
  set(values);
  onCancel();
  message.success('Данные сохранены');
};

const saveDataWithConfirm = (values, set, onCancel) => {
  confirm({
    title: `Перезаписать?`,
    content: 'У вас есть сохраненный черновик. Новый черновик заменит старый',
    onOk: () => saveData(values, set, onCancel),
    onCancel: () => {},
  });
};

const SaveDraft = ({ form, onCancel, disabled = false, className }) => {
  const [draft, setDraft] = useDraftLocalStorage();

  const handleClick = () => {
    const rawValues = form.getFieldsValue(fieldsToSave);

    if (hasAnyValue(rawValues)) {
      let values = { ...rawValues };

      // if (values[fieldNames.addresses]?.length) {
      //   const addresses = transformAddresses(
      //     values[fieldNames.addresses],
      //     false
      //   );

      //   values = { ...values, addresses };
      // }

      draft
        ? saveDataWithConfirm(values, setDraft, onCancel)
        : saveData(values, setDraft, onCancel);
    } else {
      onCancel();
      message.error('Нет данных для сохранения');
    }
  };

  return (
    <Tooltip title="Сохранятся все данные, кроме вложений">
      <Button
        onClick={handleClick}
        disabled={disabled}
        className={className}
        type="link"
      >
        Сохранить как черновик и выйти
      </Button>
    </Tooltip>
  );
};

export default SaveDraft;
